import { render, staticRenderFns } from "./PelatihanPesertaDashboard.vue?vue&type=template&id=8d2e43c8"
import script from "./PelatihanPesertaDashboard.vue?vue&type=script&lang=js"
export * from "./PelatihanPesertaDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports